import { msg } from '@lingui/core/macro';
import { defineEnum } from '@/shared/patterns/define-enum';
export const BILLING_STATUS = defineEnum({
  NotRegistered: { label: msg`Não registrada`, tone: 'neutral', icon: 'file-check' },
  Registering: { label: msg`Registrando`, tone: 'warn', icon: 'clock' },
  Registered: { label: msg`Registrada`, tone: 'ok', icon: 'circle-check' },
  Paid: { label: msg`Paga`, tone: 'ok', icon: 'circle-check' },
  PartialPaid: { label: msg`Paga parcialmente`, tone: 'warn', icon: 'clock' },
  Cancelled: { label: msg`Cancelada`, tone: 'neutral', icon: 'circle-x' },
});
